import { render, staticRenderFns } from "./BrowseButton.vue?vue&type=template&id=20050a3e"
import script from "./BrowseButton.vue?vue&type=script&lang=js"
export * from "./BrowseButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports